// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4cd860a8","732":"f2fa3afe","977":"aab6afa5"}[chunkId] + ".chunk.js";
};